export default {"src":"/_next/static/media/PHP.b35e4f78.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};